<template>
    <b-form-group>
         <div v-if="helpType == 'icon-tooltip'" > 
            <b-row>
                <b-col sm="1" md="1" lg="1">
                    <b-tooltip :show="true" :target="target" placement="top" v-if="helpType == 'icon-tooltip'"> {{ tip }} </b-tooltip>
                    <div class="seeHelpfulTip"> {{ text }}  </div>
                    <i :target="target" class="fa fa-info-circle fa-lg mt-5 seeHelpfulTip"></i> 
                </b-col>
                <b-col>
                    <slot></slot> 
                </b-col>
            </b-row>
        </div>

        <div v-if="helpType == 'icon'" > 
            <b-row>
                <b-col sm="1" md="1" lg="1">
                    <i class="fa fa-info-circle fa-lg mt-5 seeHelpfulTip" @click="modal = true"></i> 
                </b-col>
                <b-col>
                    <slot></slot> 
                </b-col>
            </b-row>
        </div>
        
        <div v-if="helpType == 'tooltip'" @click="modal = true"> 
            <slot></slot>
            <b-tooltip :show="true" :target="target" placement="top" v-if="helpType == 'tooltip'"> </b-tooltip>
            <div class="seeHelpfulTip" @click="modal = true"> {{ text }}  </div>
        </div>

        <b-modal v-model="modal" :title="title || 'Tip'" ok-only :size="size || 'md'">
            <resolver :id="tipId" />
        </b-modal>
    </b-form-group>
</template>

<style scoped>
.seeHelpfulTip {
    cursor: pointer;
    margin-top: 5px !important;
}
</style>
<script>
import Resolver from '../../components/identityFields/tooltips/Resolver'

export default {
    name: 'Helptip',
    components: {
        Resolver
    },
    props: {
        target: {
            type: String,
            default: 'helptip'
        },
        helpType: {
            type: String
        },
        text: {
            type: String
        },
        size: {
            type: String
        },
        title: {
            type: String
        },
        tipId: {
            type: String
        },
        tip: {
            type: String
        }
    },
    data: function() {
        return {
            modal: false
        }
    }
}
</script>